export const IMAGES = {
  heroMain: "https://images.unsplash.com/photo-1592903297149-37fb25202dfa?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroSecondary: "https://images.unsplash.com/photo-1707944145479-12755f0434d8?crop=entropy&cs=srgb&fm=jpg&q=85",
  bespoke: "https://images.unsplash.com/photo-1668127494486-f27a1d2b88f9?crop=entropy&cs=srgb&fm=jpg&q=85",
  boxFlat: "https://images.unsplash.com/photo-1674620213535-9b2a2553ef40?crop=entropy&cs=srgb&fm=jpg&q=85",
  packaging: "https://images.unsplash.com/photo-1545844568-98bb15133ec0?crop=entropy&cs=srgb&fm=jpg&q=85",
  artisanCeramic: "https://images.unsplash.com/photo-1706954668876-44410ebbbfa8?crop=entropy&cs=srgb&fm=jpg&q=85",
  artisanCandle: "https://images.unsplash.com/photo-1635462684825-3621c1df5403?crop=entropy&cs=srgb&fm=jpg&q=85",
  artisanGold: "https://images.unsplash.com/photo-1604166948557-0225a9f99167?crop=entropy&cs=srgb&fm=jpg&q=85",
  littleGift: "https://images.unsplash.com/photo-1559669615-7e3c14944690?crop=entropy&cs=srgb&fm=jpg&q=85",
  eventTable: "https://images.unsplash.com/photo-1594396554788-9438ff92e311?crop=entropy&cs=srgb&fm=jpg&q=85",
  founder: "https://images.unsplash.com/photo-1610377507996-dcd4f0cfc125?crop=entropy&cs=srgb&fm=jpg&q=85",
  seasonal: "https://images.unsplash.com/photo-1662813866102-24d81f218dad?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const CATEGORIES = ["All", "Self Care", "Thank You", "For Him", "Beauty"];

export const PRODUCTS = [
  {
    id: "self-care-edit",
    name: "The Self Care Edit",
    category: "Self Care",
    price: "£85",
    tagline: "Permission to slow down, beautifully wrapped.",
    contents: ["Hand-poured lavender & chamomile candle", "Botanical bath salts in amber glass", "Silk sleep mask in champagne", "Herbal wind-down tea trio", "Handwritten note card"],
    availability: "In stock",
    lead: "Ships in 1–2 days",
    image: IMAGES.artisanCandle,
    featured: true,
  },
  {
    id: "thank-you-edit",
    name: "The Thank You Edit",
    category: "Thank You",
    price: "£45",
    tagline: "Say it properly, without saying a word.",
    contents: ["Single-estate artisan chocolate bar", "Letterpress thank-you card set", "Wildflower honey jar & dipper", "Hand-tied dried flower posy", "Personal message card"],
    availability: "In stock",
    lead: "Ships in 1–2 days",
    image: IMAGES.littleGift,
    featured: true,
  },
  {
    id: "for-him-edit",
    name: "The For Him Edit",
    category: "For Him",
    price: "£95",
    tagline: "Considered, not predictable.",
    contents: ["Barrel-aged small-batch coffee", "Leather & cedar candle", "Dark & sea salt craft chocolate", "Linen-bound pocket notebook", "Handwritten note card"],
    availability: "In stock",
    lead: "Ships in 1–2 days",
    image: IMAGES.artisanGold,
    featured: true,
  },
  {
    id: "beauty-edit",
    name: "The Beauty Edit",
    category: "Beauty",
    price: "£75",
    tagline: "A vanity-table favourite, curated.",
    contents: ["Botanical face mist", "Rose clay face mask", "Nourishing neroli hand balm", "Silk hair ribbon", "Gold-foiled note card"],
    availability: "In stock",
    lead: "Ships in 1–2 days",
    image: IMAGES.artisanCeramic,
    featured: true,
  },
];

export const CONTACT = {
  email: "Salem-sabrina-thegiftedit@outlook.com",
  conciergeEmail: "Salem-sabrina-thegiftedit@outlook.com",
  phone: "07950 533 602",
  hours: "Monday – Saturday, 9am – 6pm",
};
